/**
 * @prop --wf-footer-awards-background-color: The background color of the box.
 * @prop --wf-footer-awards-title-color: The color of the box title, default (--mdc-theme-accent).
 * @prop --wf-footer-awards-title-font-size: The font size of the title.
 * @prop --wf-footer-awards-title-font-weight: The font weight of the title.
 * @prop --wf-footer-awards-title-font-size-large: The font weight of the title in medium and large viewports.
 */

:host {
    display: block;
    background-color: var(--wf-footer-awards-background-color, #f8f7f5);
    padding: 16px;
}

.title {
    line-height: 1.71;
    margin-bottom: 32px;
    color: var(--wf-footer-awards-title-color, var(--mdc-theme-accent, #ea5659ff));
    font-size: var(--wf-footer-awards-title-font-size, 0.875rem);
    font-weight: var(--wf-footer-awards-title-font-weight, bold);
}

.logos {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    place-items: center center;
    gap: 32px;
}

@media screen and (min-width: 768px) {
    :host {
        padding: 16px 0;
    }

    .title {
        margin-bottom: 8px;
        font-size: var(--wf-footer-awards-title-font-size-large, 1rem);
    }

    .logos {
        grid-template-columns: repeat(4, 1fr);
        gap: 0;

        a.wine-trophy {
            order: 2
        }

        a.ehi {
            order: 3
        }

        a.welt {
            order: 4
        }

        a.focus-money {
            order: 1
        }
    }
}


